import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
import { Overlay } from '../../styled';
export const StyledOverlay = styled(Overlay) `
  border-radius: ${theme.borderRadius.circle};
`;
